import script from "./MagazineCategories.vue?vue&type=script&setup=true&lang=js"
export * from "./MagazineCategories.vue?vue&type=script&setup=true&lang=js"

import "./MagazineCategories.vue?vue&type=style&index=0&id=f09fb5d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f09fb5d2"]])

export default __exports__